import { CreateBudgetRecommendationRunResultStatusGQLEnum } from "@north-beam/nb-client-side";

import { type ClientSetting } from "../types";

import { getClientSettingLatestBudgetGenerationResult } from "./get-client-setting-latest-budget-generation-result";

export function getIsClientSettingGeneratingBudgets(
  clientSetting: ClientSetting,
) {
  const latestRunResultStatus =
    getClientSettingLatestBudgetGenerationResult(clientSetting);

  if (!latestRunResultStatus) {
    return false;
  }

  const runningStatuses = [
    CreateBudgetRecommendationRunResultStatusGQLEnum.started,
    CreateBudgetRecommendationRunResultStatusGQLEnum.queued,
  ];

  return runningStatuses.includes(latestRunResultStatus);
}
